import { Banner } from "@shopify/polaris";
import React from "react";
import { useSelector } from "react-redux";
import { PortalState } from "../../types/PortalState";
import { UIStatus } from "../../types/UIStatus";
import styles from "../Sections/Sections.module.css";

export const WarningBanner = () => {
    const uiStatus: UIStatus = useSelector(
        (state: PortalState) => state.portal.uiStatus
    );
    const status = uiStatus.warningBannerStatus;

    if (!uiStatus.warningBannerEnabled) {
        return null;
    }

    let title = uiStatus.warningBannerTitle;

    if (status === "critical") {
        title = "Report Processing Failed";
    }

    const getMessage = () => {
        if (status === "warning") {
            return null;
        }
        return <p> {uiStatus.warningBannerTitle} </p>;
    };

    return (
        <div className={styles.banner}>
            <Banner title={title} status={status}>
                {getMessage()}
            </Banner>
        </div>
    );
};
